import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

interface NavBarProps {
  userName: string;
  onSignOut: () => void;
  showBackToDashboard?: boolean;
  onBackToDashboard?: () => void;
}

// Mobile Back Button Component
export const MobileBackButton: React.FC<{ onBackToDashboard?: () => void }> = ({ onBackToDashboard }) => {
  const navigate = useNavigate();
  
  const handleBackToDashboard = () => {
    if (onBackToDashboard) {
      onBackToDashboard();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="lg:hidden mb-4">
      <button 
        onClick={handleBackToDashboard}
        className="text-black opacity-60 hover:opacity-100 transition-opacity font-['Space_Grotesk']"
      >
        ← Back to Dashboard
      </button>
    </div>
  );
};

const NavBar: React.FC<NavBarProps> = ({ 
  userName, 
  onSignOut, 
  showBackToDashboard = false,
  onBackToDashboard 
}) => {
  const navigate = useNavigate();
  
  const handleBackToDashboard = () => {
    if (onBackToDashboard) {
      onBackToDashboard();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="fixed w-full px-4 top-[46px] z-10">
      <div className="max-w-[1257px] mx-auto h-[77px] relative rounded-[28px]">
        <div className="absolute w-full h-full top-0 left-0 bg-white rounded-[28px] shadow-[0px_4px_4px_#00000040] blur-[3.05px] opacity-[0.53]" />
        <div className="relative h-full flex items-center justify-between px-6">
          <div className="flex items-center gap-4 cursor-pointer" onClick={() => navigate('/dashboard')}>
            <img className="w-[27px] h-[27px] object-cover" alt="Beetle" src="/beetle.png" />
            <span className="font-['Space_Grotesk'] font-bold text-black text-[32px]">RAWPA</span>
          </div>
          <div className="flex items-center gap-4">
            {showBackToDashboard && (
              <Button
                variant="outline"
                onClick={handleBackToDashboard}
                className="font-['Space_Grotesk'] text-black hidden lg:flex"
              >
                Back to Dashboard
              </Button>
            )}
            <div className="w-[48px] h-[48px] bg-[#daed6e] rounded-[12px] flex items-center justify-center cursor-pointer hover:bg-[#c5d85c] transition-colors">
              <img className="w-6 h-6" alt="User" src="/user-icon.svg" />
            </div>
            <div
              onClick={onSignOut}
              className="w-[48px] h-[48px] bg-[#daed6e] rounded-[12px] flex items-center justify-center cursor-pointer hover:bg-[#c5d85c] transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBar; 